import { useQuery } from '@tanstack/react-query'

import { listDestinations, reachableOrganisations } from '@/lib/auth/shell'

export const shellKeys = {
  all: ['shell'] as const,
  organisations: (application: string) => [...shellKeys.all, 'organisations', application] as const,
  destinations: () => [...shellKeys.all, 'destinations'] as const,
}

/**
 * The organisations the switcher offers. Asked for once the menu has a
 * session to ask about; not retried — without it the switcher just shows
 * the current organisation.
 */
export function useReachableOrganisations(application: string | undefined) {
  return useQuery({
    queryKey: shellKeys.organisations(application ?? ''),
    queryFn: () => reachableOrganisations(application ?? ''),
    enabled: Boolean(application),
    staleTime: 5 * 60_000,
    retry: false,
  })
}

/** The other front ends, for the launcher. The service caches it for a minute. */
export function useDestinations() {
  return useQuery({
    queryKey: shellKeys.destinations(),
    queryFn: listDestinations,
    staleTime: 5 * 60_000,
    retry: false,
  })
}
